import { FormKitNode } from '@formkit/core';
import { DEBUG_NAMESPACE, useDebug } from '@/composables/useDebug';
import { useVideoMergeStore } from '@/modules/viewer/store/useVideoMergeStore';

const { debug } = useDebug(DEBUG_NAMESPACE.VALIDATORS);

export const zightLink = (node: FormKitNode, type: string) => {
  const videoMergeStore = useVideoMergeStore();
  const { value } = node;

  switch (type) {
    case 'video':
      return videoMergeStore
        .validateUrl(value as string)
        .then(() => {
          return true;
        })
        .catch(err => {
          debug('video failed:', err);
          return false;
        });
      break;
    default:
      debug(`Unsupported type: ${type}`);
      return false;
  }
};
